import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';
import { UserOutlined, MailOutlined, QuestionCircleOutlined, SendOutlined } from '@ant-design/icons';
import './ContactMe.css'
import Footer from '../shared/footer/index'
import Zoom from 'react-reveal/Zoom';
import * as emailjs from 'emailjs-com'
import email_config from '../../const/email_config'
import Notification from '../shared/notification/Notification'


const validateMessages = {
    required: '${name} is required!',
    types: {
        email: '${name} is not a valid email!',
        number: '${name} is not a valid number!',
    }
};



const ContactMe = () => {

    const [form] = Form.useForm();

    const [loadings, setLoadings] = useState(false)



    const onFinish = () => {

        const values = form.getFieldsValue()

        setLoadings(true)

        let templateParams = {
            name: values.Name,
            from_name: values.Email,
            to_name: email_config.to_email,
            subject: values.Subject,
            message: values.Introduction,
        }

        emailjs.send(
            email_config.service_name,
            email_config.email_template,
            templateParams,
            email_config.user_id
        ).then((result) => {

            resetForm()

        }, (error) => {

            Notification('error', 'Email Error', 'Server Error Please try again')
        });


    };

    const resetForm = () => {

        form.resetFields();
        setLoadings(false)
        Notification('success', 'Email Success', 'Your email has been sent successfully')

    }


    return (
        <div id="contact" className="contact_me_container">

            <div className="contact_me_tittle">
                <h4>Get In Touch</h4>
                <p> Hello Visitor !! <br />
                        Thank you for bumping in. If you have any propositions & projects, feel free to PING me.
                        I am always open for discussion. You can contact me via the Contact Form OR simply click on the social media icon if you are more comfortable there.</p>
            </div>

            <Zoom >
                <div className="contact_me_form">
                    <Form form={form} name="nest-messages" onFinish={onFinish} validateMessages={validateMessages}  >
                        <Form.Item
                            name={['Name']}
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Name" name='name' />
                        </Form.Item>
                        <Form.Item
                            name={['Email']}
                            rules={[
                                {
                                    required: true,
                                    type: 'email',
                                },
                            ]}
                        >
                            <Input prefix={<MailOutlined className="site-form-item-icon" />} placeholder="Email" name='email' />
                        </Form.Item>

                        <Form.Item
                            name={['Subject']}
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input prefix={< QuestionCircleOutlined className="site-form-item-icon" />} placeholder="Subject" name='subject' />
                        </Form.Item>
                        <Form.Item name={['Introduction']} rules={[
                            {
                                required: true,
                            },
                        ]}>
                            <Input.TextArea placeholder="Introduction" autoSize={{ minRows: 6, maxRows: 10 }} name='introduction' />
                        </Form.Item>
                        <Form.Item >
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<SendOutlined />}
                                loading={loadings}

                            >
                                Submit
                                </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Zoom >
            <Footer />
        </div>
    )
}


export default ContactMe
